/**
 * pRI LLM Settings API Client
 * Epic E-PRI-3: pRI LLM Beállítások Admin Felület
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export interface PriLlmConfig {
  tenantId: string;
  geminiApiKeyMasked: string | null;
  provider: string;
  enabled: boolean;
  userPerMinLimit: number;
  tenantPerMinLimit: number;
  userPerDayLimit: number;
  sonnetPerMinLimit: number;
  monthlyQuotaBasic: number;
  monthlyQuotaPro: number;
  monthlyQuotaEnterprise: number;
  defaultTier: string;
  autoDowngradeEnabled: boolean;
  updatedBy: string | null;
  updatedAt: string | null;
}

export interface UpdatePriLlmConfigInput {
  geminiApiKey?: string;
  provider?: string;
  enabled?: boolean;
  userPerMinLimit?: number;
  tenantPerMinLimit?: number;
  userPerDayLimit?: number;
  sonnetPerMinLimit?: number;
  monthlyQuotaBasic?: number;
  monthlyQuotaPro?: number;
  monthlyQuotaEnterprise?: number;
  defaultTier?: string;
  autoDowngradeEnabled?: boolean;
}

export interface PriConnectionTestResult {
  ok: boolean;
  model: string;
  latencyMs: number;
  error?: string;
}

export interface PriUsageStats {
  totalRequests: number;
  totalCostUsd: number;
  totalInputTokens: number;
  totalOutputTokens: number;
}

// ============================================
// API FUNCTIONS
// ============================================

export async function getPriSettings(): Promise<{ data: PriLlmConfig }> {
  return api.get<{ data: PriLlmConfig }>('/admin-center/pri-settings');
}

export async function updatePriSettings(
  input: UpdatePriLlmConfigInput
): Promise<{ data: PriLlmConfig }> {
  return api.patch<{ data: PriLlmConfig }>('/admin-center/pri-settings', input);
}

export async function testPriConnection(): Promise<{ data: PriConnectionTestResult }> {
  return api.post<{ data: PriConnectionTestResult }>('/admin-center/pri-settings/test');
}

export async function getPriUsageStats(): Promise<{ data: PriUsageStats }> {
  return api.get<{ data: PriUsageStats }>('/admin-center/pri-settings/usage');
}
